export default {
  VENDOR: 1,
  OWNER: 2,
  OPERATOR: 3,
  BANK: 4,
  PURCHASER: 5,
};
